/**
 * Všechny adresy (API, WebSocket, odkazy) se skládají tady, takže případné nasazení pod prefixem
 * (např. /tcmark) je změna konfigurace (BASE_PATH při buildu), ne refaktor.
 */
const rawBase: string = import.meta.env.BASE_URL ?? '/';

/** Prefix bez koncového lomítka: '' nebo '/tcmark'. */
export const BASE_PATH = rawBase.replace(/\/+$/, '');

export const apiUrl = (path: string): string => `${BASE_PATH}${path}`;

/** Cesta v rámci appky (pro odkazy a navigaci mimo router). */
export const appPath = (path: string): string => `${BASE_PATH}${path}`;

export function wsUrl(loc: Pick<Location, 'protocol' | 'host'> = window.location): string {
  const proto = loc.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${loc.host}${BASE_PATH}/ws`;
}

/** Úplná adresa pro sdílení (QR, kopírování): veřejná URL serveru + prefix + cesta. */
export function absoluteUrl(publicUrl: string, path: string): string {
  return `${publicUrl.replace(/\/+$/, '')}${BASE_PATH}${path}`;
}

/** Adresy odkazů session. */
export const linkPaths = {
  phone: (token: string) => `/p/${token}`,
  control: (token: string) => `/r/${token}`,
  calibrate: (token: string, sourceId?: string) =>
    `/k/${token}${sourceId ? `?source=${encodeURIComponent(sourceId)}` : ''}`,
  slate: (token: string) => `/k/${token}/slate`,
};
